
import { Vue, Options } from "vue-class-component";
import { formatPrice } from "@/app/infrastructures/misc/Utils";
import { LastBalanceController } from "@/app/ui/controllers/LastBalanceController";
import { LastBalanceV2Data } from "@/domain/entities/LastBalanceV2";
import PageListLastBalance from "@/app/ui/views/finance/last-balance-v2/components/page-list-last-balance.vue";
import whatsapp from "@/app/infrastructures/misc/common-library/Whatsapp";
import formatDate from "@/app/infrastructures/misc/common-library/FormatDate";

@Options({
  components: {
    PageListLastBalance
  }
})
export default class ListLastBalanceClient extends Vue {
  tab = "client";

  maskPhone = (phone: string) => {
    if (!phone) return "";
    const clean = phone.replace(/[^0-9]/g, "");
    if (clean.length <= 6) return clean;
    const start = clean.slice(0, 4);
    const end = clean.slice(-3);
    return `${start}*****${end}`;
  };

  onClickWhatsapp(item: LastBalanceV2Data) {
    whatsapp(item.picNumber);
  }

  // Table
  columns = [
    {
      name: "Kode Klien",
      styleHead: "w-3/12 text-left whitespace-no-wrap",
      styleBody: "text-red-lp-200 text-center",
      render: (item: LastBalanceV2Data) => {
        return `<span class='text-left text-red-lp-200 flex justify-center' style="font-size: 14px;">${item.code}</span>`;
      },
    },
    {
      name: "Nama Klien",
      styleHead: "w-3/12 text-left whitespace-no-wrap",
      styleBody: "",
      render: (item: LastBalanceV2Data) => {
        return `<span class="overflow-ellipsis text-black-lp-300" style="font-size: 14px;">${item.name}</span>`;
      },
    },
    {
      name: "Saldo Terakhir",
      styleHead: "w-3/12 text-left whitespace-no-wrap",
      render: (item: LastBalanceV2Data) => {
        return `${this.formatBalanceStyle(item)}`;
      },
    },
    {
      name: "Transaksi Terakhir",
      styleHead: "w-3/12 text-left whitespace-no-wrap",
      render: (item: LastBalanceV2Data) => {
        /*const months = ["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"];
        const raw = item.lastTransaction || "";
        const [datePart, timePart] = raw.split(" ");
        const [year, month, day] = datePart ? datePart.split("-") : ["","",""];
        const formatted = datePart
          ? `${parseInt(day)} ${months[parseInt(month) - 1]} ${year} - ${timePart || ""}`
          : "-";*/
        return `<div class='flex text-black-lp-300' style="font-size: 14px;">${formatDate(item.lastTransaction)}</div>`;
      },
    },
    {
      name: "Nama PIC",
      styleHead: "w-3/12 text-center whitespace-no-wrap",
      onClickValue: (item: LastBalanceV2Data) => {
        this.onClickWhatsapp(item);
      },
      render: (item: LastBalanceV2Data) => {
        return `
          <div class='flex flex-col items-start justify-start text-black-lp-300 w-full'>
            <span style="font-size: 14px;">${item.picName}</span>
            <div class='flex gap-x-1 mt-1 cursor-pointer'>
              <img src="${require("@/app/ui/assets/svg/whatsapp.svg")}" style="height: 20px; width: 20px;" />
              <span style="color: #36B37E; font-weight: 500; font-size: 14px;">${this.maskPhone(item.picNumber)}</span>
            </div>
          </div>
        `;
      },
    }
  ];

  formatBalanceStyle(item: LastBalanceV2Data) {
    return `<span class="overflow-ellipsis ${
      item.lastBalance < 0 ? "text-red-lp-750" : "text-green-lp-100"
    }" style="font-size: 14px;"> ${formatPrice(item.lastBalance, "+ ", item.countryCurrency)}</span>`;
  }
}
